import { Button } from "components/Button";
import { Alert } from "components/common/Alert/Alert";
import { Checkbox } from "components/common/Checkbox/Checkbox";
import { CustomStructuredText } from "components/CustomStructuredText/CustomStructuredText";
import { useTranslationContext } from "context/translation";
import { RegisterMachineFormValues } from "hooks/machineRegistration/useMachineRegistrationForm";
import { FC } from "react";
import { Field, FormRenderProps } from "react-final-form";
import { RichTextBlockFragment } from "services/datocms/generated";

type CompleteRegistrationProps = {
  emailLabel?: RichTextBlockFragment | null;
  termsLabel?: RichTextBlockFragment | null;
  formProps: FormRenderProps<
    RegisterMachineFormValues,
    Partial<RegisterMachineFormValues>
  >;
};

export const CompleteRegistration: FC<CompleteRegistrationProps> = ({
  emailLabel,
  termsLabel,
  formProps,
}) => {
  const { completeYourRegistration } = useTranslationContext();
  return (
    <div className="bg-white p-10 rounded-[20px] border border-gray-200 flex flex-col gap-8">
      {formProps.submitError && (
        <Alert type="error">{formProps.submitError}</Alert>
      )}
      {formProps.touched?.terms && formProps.errors?.terms && (
        <Alert type="error">{formProps.errors?.terms}</Alert>
      )}

      {emailLabel && (
        <Field name="registrationEmailOptIn" type="checkbox">
          {(props) => (
            <Checkbox
              {...props.input}
              id="registrationEmailOptIn"
              label={
                <CustomStructuredText
                  className="text-xs"
                  content={emailLabel}
                />
              }
            />
          )}
        </Field>
      )}

      {termsLabel && (
        <Field name="terms" type="checkbox">
          {({ input, meta }) => (
            <Checkbox
              {...input}
              id="terms"
              error={meta.touched && meta.error}
              label={
                <CustomStructuredText
                  className="text-xs [&_a]:underline"
                  content={termsLabel}
                />
              }
            />
          )}
        </Field>
      )}
      <Button
        loading={formProps.submitting}
        onClick={() => {
          const errors = Object.keys(formProps.errors ?? {});
          if (errors.length > 0) {
            const el = document.querySelector(`[name=${errors[0]}]`);
            el?.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "start",
            });
          }
          formProps.handleSubmit();
        }}
        className="max-w-[400px]"
        type="submit"
      >
        {completeYourRegistration}
      </Button>
    </div>
  );
};
